import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

export function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-slate-900 px-4" aria-label="Call to action">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-orange-400 text-xs font-bold uppercase tracking-widest mb-5">Ready when you are</p>
        <h2
          className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight"
          style={{ fontFamily: 'Manrope' }}
          data-testid="cta-headline"
        >
          Stop doing payroll
          <br />
          <span className="text-orange-400">manually.</span>
        </h2>
        <p className="mt-6 text-lg text-slate-400 max-w-xl mx-auto leading-relaxed">
          Join businesses already using ReStaff to schedule staff, track hours, and run payroll — without the spreadsheets.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/register">
            <Button
              size="lg"
              className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-base px-10 rounded-full shadow-lg shadow-orange-500/20 hover:shadow-orange-500/30 hover:scale-105 transition-all duration-200"
              data-testid="cta-btn"
            >
              Run Your First Payroll
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </Link>
          <Link to="/register" className="hidden sm:inline-block">
            <Button
              size="lg"
              variant="outline"
              className="w-full sm:w-auto border-slate-700 text-slate-300 hover:bg-slate-800 text-base rounded-full"
            >
              Start Free Trial
            </Button>
          </Link>
        </div>
        <p className="mt-5 text-sm text-slate-500">30-day free trial &nbsp;·&nbsp; Cancel anytime — no questions asked</p>
      </div>
    </section>
  );
}
